class MFRBundle {
  constructor(data) {
    this.$element = $('body')

    this.selectors = {
      addButton: '[data-mfr-add-to-bundle]',
      removeButton: '[data-mfr-remove-to-bundle]',
      bundleSection: '[data-mfr-bundle-section]',
      bundler: '[data-mfr-bundler]',
      submit: '[data-mfr-bundler-submit]',
      subscription: '[name="subscription_type"]',
      removeBundleFromCart: '[data-mfr-remove-bundle]',
    }

    window.mfrBundle = {}

    this.limit = data.limit
    this.maxPerProduct = data.maxPerProduct
    this.minimumProducts = data.minimumProducts

    this.init()
  }

  init() {
    this.$bundleSection = this.$element.find(this.selectors.bundleSection)

    if (this.$bundleSection.length) this.initBundler()

    $(document).on('click', this.selectors.addButton, this.__handleAddButtonClick.bind(this))
    $(document).on('click', this.selectors.removeButton, this.__handleRemoveButtonClick.bind(this))
    $(document).on('click', this.selectors.removeBundleFromCart, this.__handleRemoveBundleFromCart.bind(this))
  }

  __handleAddButtonClick(e) {
    e.preventDefault()

    if (this.limit <= this.getBundleQuantity() && this.limit > 0) return

    const variantID = $(e.currentTarget).attr('data-mfr-add-to-bundle')
    const price = $(e.currentTarget).data('mfr-bundle-price')
    const selling_plan = $(e.currentTarget).data('mfr-bundle-selling_plan')
    const quantity = Boolean(window.mfrBundle[variantID]) ? window.mfrBundle[variantID].quantity + 1 : 1

    // BRENDAN –––––– show indicator and remove button
    const parent = $(e.currentTarget).closest('.bundle-product__button-wrap')
    const indicator = parent.find('.bundle-product__count')
    const remove_button = parent.find('.bundle-product__remove')
    indicator.show()
    remove_button.show()
    indicator.text(quantity)
    // BRENDAN END

    window.mfrBundle[variantID] = {
      quantity: quantity,
      price: price,
      selling_plan: selling_plan,
    }

    $(document).trigger('mfr-bundle:bundle-changed')

    //if (this.maxPerProduct <= window.mfrBundle[variantID].quantity && this.maxPerProduct > 0) this.changeToRemove(variantID)
    //this.enableDisableButtons()
  }

  __handleRemoveButtonClick(e) {
    e.preventDefault()

    const variantID = $(e.currentTarget).attr('data-mfr-remove-to-bundle')
    delete window.mfrBundle[variantID]

    $(document).trigger('mfr-bundle:bundle-changed')

    // BRENDAN –––––– reset and hide indicator and remove button
    const parent = $(e.currentTarget).closest('.bundle-product__button-wrap')
    const indicator = parent.find('.bundle-product__count')
    $(e.currentTarget).hide()
    indicator.hide()
    indicator.text(0)
    // BRENDAN END

    // this.changeToAdd(variantID)
    // this.enableDisableButtons()
  }

  __handleRemoveBundleFromCart(e) {
    /*
        const $button = $( e.currentTarget );
        const bundleHash = $button.attr( "data-mfr-remove-bundle" ); //dont use data(), it will not work if rivets doesnt bind the data and just added attribute to the html
        const items = CartJS.cart.items;
        var itemIds = [];
        var movementLineNumber = 0;

        //get all variant_id with same properties.bundle_hash
        $.each(items, function (index, item) {
            const itemBundleHash = item.properties._bundle_hash;

            if ( itemBundleHash == bundleHash ) { //old: itemBundleHash == bundleHash -- changed to if has there's a bundle hash instead of checking if thats the remove bundle button for that product
            // itemIds.push(item.variant_id);
            
            // using new CartJS.removeItem via line number instead of variant id
            CartJS.removeItem( index - movementLineNumber + 1 );
                movementLineNumber = movementLineNumber + 1; //movementLineNumber is for adjustment on index when removing item it always diminishes by 1.
            }

        });
        */

    const $button = $(e.currentTarget)
    const bundleHash = $button.attr('data-mfr-remove-bundle') //dont use data(), it will not work if rivets doesnt bind the data and just added attribute to the html
    const items = CartJS.cart.items
    let productsToRemove = {}

    //get all key with same properties._bundle_hash
    $.each(items, (index, item) => {
      const itemBundleHash = item.properties._bundle_hash
      if (itemBundleHash == bundleHash) {
        productsToRemove[item.key] = 0
      }
    })

    $('.cart-form').addClass('loading')
    this.processRemove(items, bundleHash)
    this.resetProductCards()
  }

  processRemove(items, hash) {
    let foundObject = items.find((object) => object.properties._bundle_hash == hash)
    let payload = {}
    payload[foundObject.key] = 0

    if (foundObject) {
      $.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/update.js',
        data: {
          updates: payload,
        },
        dataType: 'json',
        success: (e) => {
          if (e.items.find((object) => object.properties._bundle_hash == hash)) {
            this.processRemove(e.items, hash)
          } else {
            CartJS.getCart()
          }
        },
        error: (e) => {
          console.log('error', e)
        },
      })
    } else {
      CartJS.getCart()
    }
  }

  getBundleQuantity() {
    let quantity = 0
    if (!Object.keys(window.mfrBundle).length) return quantity

    $.each(window.mfrBundle, (i, e) => {
      quantity += e.quantity
    })

    return quantity
  }

  getBundlePrice() {
    let price = 0
    if (!Object.keys(window.mfrBundle).length) return price

    $.each(window.mfrBundle, (i, e) => {
      price += parseFloat(e.price * e.quantity)
    })

    return price
  }

  getDiscountedPrice() {
    const subscriptionType = $(`[name="subscription_type"]:checked`)
    const discount = subscriptionType.data('mfr-bundle-discount') / 100
    return (this.getBundlePrice() - this.getBundlePrice() * discount).toFixed(2)
  }

  enableDisableButtons() {
    if (this.limit <= this.getBundleQuantity() && this.limit > 0) {
      $(this.selectors.addButton).addClass('disabled')
      $.each(window.mfrBundle, (variant_id, quantity) => {
        this.changeToRemove(variant_id)
      })
    } else {
      $(this.selectors.addButton).removeClass('disabled')
    }
  }
  // BRENDAN –––––– reset and hide indicators and remove buttons
  resetProductCards() {
    $('.bundle-product__count').each(function () {
      $(this).text(0)
      $(this).hide()
    })
    $('.bundle-product__remove').each(function () {
      $(this).hide()
    })
  }
  // BRENDAN END
  changeToRemove(variantID) {
    console.log('CTR')
    this.$element
      .find(`[data-mfr-add-to-bundle="${variantID}"]`)
      .removeClass('disabled')
      .removeClass('add')
      .removeAttr('data-mfr-add-to-bundle')
      .addClass('remove')
      .attr('data-mfr-remove-to-bundle', variantID)
      .find('.text')
      .text('Remove')
  }

  changeToAdd(variantID) {
    this.$element
      .find(`[data-mfr-remove-to-bundle="${variantID}"]`)
      .removeClass('disabled')
      .removeClass('remove')
      .removeAttr('data-mfr-remove-to-bundle')
      .addClass('add')
      .attr('data-mfr-add-to-bundle', variantID)
      .find('.text')
      .text('add')
  }

  initBundler() {
    this.$bundler = this.$element.find(this.selectors.bundler)
    this.$submit = this.$element.find(this.selectors.submit)
    this.$subscription = this.$element.find(this.selectors.subscription)

    if (!this.$bundler.length) return

    window.mfrScroll.on('scroll', (args) => {
      let inView = false
      let progress = 0

      $.each(args.currentElements, (i, e) => {
        const element = $(e.el)
        const attr = element.attr('data-mfr-bundle-section')

        if (typeof attr !== 'undefined' && attr !== false ) {
          const sectionContentPercentage = element.find( ".section-content:first-child" ).height() / element.height() * 100;
          progress = args.currentElements[element.attr('data-scroll-id')].progress * 100;
          if( args.scroll.y + $( "header.header" ).height() >= args.currentElements[element.attr('data-scroll-id')].top ) {
            inView = true
            return false
          }
        }
      })

      if (typeof args.currentElements['footer'] === 'object') {
        if (args.currentElements['footer'].progress * 100 >= 10) {
          inView = false
        }
      }

      if (inView) this.$bundler.addClass('show')
      else this.$bundler.removeClass('show')
    })

    this.updateItems()

    $(document).on('mfr-bundle:bundle-changed', this.__handleBundleChange.bind(this))
    this.$subscription.on('change', (e) => {
      this.updatePrice()
    })
    this.$submit.on('click', this.__handleBundlerSubmit.bind(this))
  }

  __handleBundleChange(e) {
    this.updateItems()
  }

  __handleBundlerSubmit(e) {
    if (this.minimumProducts != this.getBundleQuantity()) return
    const bundle = window.mfrBundle
    let payload = []
    const subscriptionType = $(`[name="subscription_type"]:checked`)
    const bundleHash = this.generateID()

    $.each(bundle, (i, e) => {
      let properties = {
        _bundle_hash: bundleHash,
        _added_by: 'MFR Bundle Builder',
      }

      let args = {
        id: i,
        quantity: e.quantity,
      }

      if (subscriptionType.val() == 'subscription' && e.selling_plan) {
        args['selling_plan'] = e.selling_plan
        properties['_selling_plan_id'] = e.selling_plan
      }

      args['properties'] = properties

      payload.push(args)
    })

    if (CartJS) {
      if (CartJS.addItems) {
        CartJS.addItems(payload)
      }
    }

    this.resetBundler()
  }

  updateItems() {
    this.updateRemainingItems()
    this.updatePrice()
  }

  updateRemainingItems() {
    const value = this.$submit.find('.quantity').find('.value')
    const remaining = this.minimumProducts - this.getBundleQuantity()

    if (remaining == 0) {
      this.$submit.find('.quantity').hide()
      this.$submit.find('.add-to-cart-text').show()
      this.$submit.removeClass('disabled')
    } else {
      this.$submit.find('.quantity').show()
      this.$submit.find('.add-to-cart-text').hide()
      this.$submit.addClass('disabled')
    }

    value.text(this.minimumProducts - this.getBundleQuantity())
  }

  updatePrice() {
    const value = this.$submit.find('.price').find('.value')

    value.text(this.getDiscountedPrice())
  }

  generateID() {
    return 'mfr-bundle-' + Math.floor(Date.now() / 1000).toString(16) + Math.random().toString(16).substr(2, 8)
  }

  resetBundler() {
    window.mfrBundle = {}

    this.$element.find(this.selectors.removeButton).each((i, e) => {
      const element = $(e)
      const variantID = element.attr('data-mfr-remove-to-bundle')

      this.changeToAdd(variantID)
    })
    this.$element.find(this.selectors.addButton).removeClass('disabled')

    this.updateItems()
    this.resetProductCards()
  }
}
